import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import React, { useCallback } from "react";

const CustomSelectFilter = ({
  menuItems,
  changeSelectValueHandler,
  selectValue,
  id,
  label,
  minWidth = 178,
  placeholder,
  size = "small",
  disabled = false,
  fontSize = "1.6rem",
  IconComponent,
  iconColor,
  multiple = false,
  MenuProps,
  maxWidth,
  outlined = true,
}) => {
  const valueToLabel = React.useCallback(
    (val) => menuItems?.find((m) => m.value === val)?.title ?? val,
    [menuItems]
  );

  const renderSelectedAsText = useCallback(
    (selected) => {
      if (!selected || (Array.isArray(selected) && selected.length === 0)) {
        return placeholder ? <em>{placeholder}</em> : null;
      }

      const values = Array.isArray(selected) ? selected : [selected];
      const labels = values.map((v) => valueToLabel(v)).filter(Boolean);
      const text = labels.join(", ");

      return (
        <Typography
          variant="body2"
          sx={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "block",
            maxWidth: "100%",
          }}
        >
          {text}
        </Typography>
      );
    },
    [placeholder, valueToLabel]
  );

  return (
    <FormControl
      sx={{ maxWidth: maxWidth, width: minWidth }}
      size={size}
      disabled={disabled}
    >
      <InputLabel id={id} sx={{ fontSize }}>
        {label}
      </InputLabel>
      <Select
        sx={{
          fontSize: fontSize,
          "& .MuiSvgIcon-root": {
            color: iconColor && iconColor,
          },
          background: !outlined && "#F4F6F8",
          "&:before": {
            borderColor: !outlined && "white !important",
          },
          "&:after": {
            borderColor: !outlined && "white !important",
          },
          boxShadow: !outlined && "none !important",
          ".MuiOutlinedInput-notchedOutline": {
            border: !outlined && "0  !important",
          },
        }}
        labelId={id}
        displayEmpty={placeholder ? true : false}
        placeholder={placeholder && placeholder}
        id={id}
        multiple={multiple}
        value={selectValue}
        label={label && label}
        onChange={changeSelectValueHandler}
        variant="outlined"
        IconComponent={IconComponent && IconComponent}
        MenuProps={MenuProps}
        renderValue={multiple ? renderSelectedAsText : undefined}
      >
        {placeholder && (
          <MenuItem disabled value="">
            <em>{placeholder}</em>
          </MenuItem>
        )}
        {/* <MenuItem value="all">All</MenuItem> */}
        {menuItems?.map((item, index) => (
          <MenuItem key={index} value={item?.value}>
            <Box
            // sx={{
            //   maxWidth: minWidth,
            //   overflow: "hidden",
            //   textOverflow: "ellipsis",
            //   whiteSpace: "nowrap",
            // }}
            >
              {item?.title}
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CustomSelectFilter;
